module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics/cd1//Track_38_Carnival_Dance.mp3";